var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-identifier"},[_c('div',{staticClass:"c-identifier",style:(("background-color:" + _vm.color))}),(_vm.$slots.default)?[_vm._t("default")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }